import { Observable } from 'rxjs';
import { SavedDeviceInfo, UniversalCustomerDisplayDevice } from './UniversalCustomerDisplayDevice';

export abstract class IDiscovery<Device extends UniversalCustomerDisplayDevice<ConnectionInfo>, ConnectionInfo> {
  abstract get discoveryId(): string;

  /**
   * Eager discoveries are cheap, zero-config peripherals that must be found
   * without any prior pairing — e.g. the built-in (in-app) secondary display
   * on Android, which stays in Android's default mirror mode until we find it
   * and auto-connect (enable('customer')). They are started unconditionally at
   * turnOn(). Lazy discoveries (network/Zeroconf) carry the iOS mDNS resolver
   * cost and are started on demand only when a display is saved/paired.
   */
  abstract get eager(): boolean;

  abstract startDiscovery(): void;

  abstract stopDiscovery(): void;

  abstract get devices(): Observable<Device[]>;

  abstract getDeviceInfo(device: Device): SavedDeviceInfo;

  abstract restoreDeviceFromInfo(deviceInfo: SavedDeviceInfo): Device;
}
